import URI from 'urijs';
import AppConfig from '../../../constants/AppConfig';
import UrlConst from '../../../constants/UrlConst';
import apiClient from '../../../services/common/apiClient';
import {
    makeGetRequestSettings,
    makePatchRequestSettings,
    makeUrl,
} from '../../../services/common/utils';
import { IProduct, IProductAssignment } from '../types';

export interface IGetProductEmptyAssignmentsParams {
    name: string;
    excludedProductId?: number;
}

export interface IRestPatchProduct {
    monitoredId: string;
}

export interface IRestPatchProductAssignments {
    added: IRestPatchProduct[];
    removed: IRestPatchProduct[];
}

export const makeProductsUrl = (suffix: string, params = {}) => {
    const url = new URI(
        AppConfig.instance.getUrl(UrlConst.PRODUCTS_ENDPOINT_URL) + suffix
    );
    return makeUrl(url, params);
};

export const restPatchProductAssignments = (
    id: number,
    assignments: IRestPatchProductAssignments
): Promise<null> =>
    apiClient.sendWithoutErrorsHandling(
        makePatchRequestSettings(
            makeProductsUrl(`/${id}/assignments`),
            assignments
        )
    );

export const restGetProductsEmptyAssignments = (
    queryParams: IGetProductEmptyAssignmentsParams
): Promise<IProductAssignment[]> =>
    apiClient
        .send(
            makeGetRequestSettings(makeProductsUrl(`/assignments`, queryParams))
        )
        .then(mapToProductAssignments);

export const restGetProductAssignments = (
    id: number
): Promise<IProductAssignment[]> =>
    apiClient
        .send(makeGetRequestSettings(makeProductsUrl(`/${id}/assignments`)))
        .then(mapToProductAssignments);

const mapToProductAssignments = (
    data: { monitoredId: number; name: string }[]
): IProductAssignment[] =>
    data.map((item) => ({
        relationId: String(item.monitoredId),
        name: item.name,
    }));

export const restGetProducts = (): Promise<IProduct[]> =>
    apiClient.send(makeGetRequestSettings(makeProductsUrl(``)));
